import type { SportProfile } from '@/types'

export const softballFastpitchWomens: SportProfile = {
  id: 'softball-fastpitch-womens',
  sport: 'softball',
  gender: 'womens',
  environment: 'outdoor',
  label: "Women's Fastpitch Softball",
  emoji: '🥎',
  playersOnField: 9,
  contactLevel: 'limited',
  hasShotClock: false,
  hasBattingOrder: true,
  periods: { label: 'Inning', count: 7, durationMinutes: 20 },
  positions: [
    { key: 'pitcher',       label: 'Pitcher',        shortLabel: 'P'   },
    { key: 'catcher',       label: 'Catcher',         shortLabel: 'C'   },
    { key: 'first_base',    label: 'First Base',      shortLabel: '1B'  },
    { key: 'second_base',   label: 'Second Base',     shortLabel: '2B'  },
    { key: 'third_base',    label: 'Third Base',      shortLabel: '3B'  },
    { key: 'shortstop',     label: 'Shortstop',       shortLabel: 'SS'  },
    { key: 'left_field',    label: 'Left Field',      shortLabel: 'LF'  },
    { key: 'center_field',  label: 'Center Field',    shortLabel: 'CF'  },
    { key: 'right_field',   label: 'Right Field',     shortLabel: 'RF'  },
    { key: 'dp',            label: 'Designated Player', shortLabel: 'DP' },
  ],
  stats: [
    { key: 'hit',         label: 'Hit',                  shortLabel: 'H'   },
    { key: 'double',      label: 'Double',                shortLabel: '2B'  },
    { key: 'triple',      label: 'Triple',                shortLabel: '3B'  },
    { key: 'home_run',    label: 'Home Run',              shortLabel: 'HR'  },
    { key: 'rbi',         label: 'RBI',                   shortLabel: 'RBI' },
    { key: 'run',         label: 'Run Scored',            shortLabel: 'R'   },
    { key: 'walk',        label: 'Walk',                  shortLabel: 'BB'  },
    { key: 'strikeout',   label: 'Strikeout (batting)',   shortLabel: 'K'   },
    { key: 'stolen_base', label: 'Stolen Base',           shortLabel: 'SB'  },
    { key: 'error',       label: 'Error',                 shortLabel: 'E'   },
    { key: 'strikeout_p', label: 'Strikeout (pitching)',  shortLabel: 'KP'  },
    { key: 'walk_p',      label: 'Walk (pitching)',       shortLabel: 'BBP' },
    { key: 'hit_allowed', label: 'Hit Allowed',           shortLabel: 'HA'  },
  ],
}
